var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"videoPlayer",staticClass:"fragment-media--video-player"},[(!_vm.lazyload || _vm.isVisible)?_c('VideoPlayer',{attrs:{"type":_vm.type,"data":_vm.content,"ads":_vm.ads}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }